import React from 'react';
import ReactDOM from 'react-dom';
import Root from './App';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';

ReactDOM.render(
  <Root />,
  document.getElementById('root')
);
